import React, {useEffect, useState} from 'react';
import classes from "./admin.module.css";
import Header from "./common/header/header";
import {getPaymentsAPI} from "./api";

const Payments = () => {
    const [data, setData] = useState([])
    const [valueDate, setValueDate] = useState(() => {
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        return oneWeekAgo.toISOString().split('T')[0]; // Формат YYYY-MM-DD
    })

    const getPayments = async ()=>{
        const res = await getPaymentsAPI()
        if(res){
            setData(res)
        }
    }

    useEffect(()=>{
        getPayments()
    },[])

    const groupedByDate = data.filter(item=>{
        const itemDate = new Date(item.date);
        const cutoffDate = new Date(valueDate);
        return itemDate > cutoffDate;
    }).reduce((acc, payment) => {
        const dateKey = payment.date.split('T')[0].split('-').reverse().join('.')

        if (!acc[dateKey]) {
            acc[dateKey] = { total: 0, payments: [] };
        }

        acc[dateKey].total += payment.sum;
        acc[dateKey].payments.push({
            ...payment,
            time: payment.date.split('T')[1].split(':')[0]+':'+payment.date.split('T')[1].split(':')[1]
        });

        return acc;
    }, {});

    const sortedDates = Object.entries(groupedByDate)
        .sort(([a], [b]) => new Date(b.split('.').reverse().join('-')) - new Date(a.split('.').reverse().join('-')));


    return (
        <div>
            <Header/>
            <div style={{padding: '20px'}}>
                <input type={"date"} value={valueDate} onChange={e=>setValueDate(e.target.value)}/>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'monospace', marginTop:'10px' }}>
                    <tbody>
                    {sortedDates.map(([date, data]) => (
                        <>
                            {/* Строка с датой и общей суммой */}
                            <tr key={`header-${date}`}>
                                <td style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold', color:'#FFF' }}>
                                    {date}
                                </td>
                                <td colSpan={2} style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold', textAlign:'right', color:'#FFF' }}>
                                    {data.total}₽
                                </td>
                            </tr>

                            {/* Детальные строки */}
                            {data.payments
                                .sort((a, b) => new Date(b.date) - new Date(a.date))
                                .map((payment, index) => (
                                    <tr key={`${date}-${index}`}>
                                        <td style={{ padding: '0px 8px', border: '1px solid #ddd', color:'#FFF' }}>
                                            {payment.time}
                                        </td>
                                        <td style={{ padding: '0px 8px', border: '1px solid #ddd', color:'#FFF' }}>
                                            {payment.telegram_id}
                                        </td>
                                        <td style={{ padding: '0px 8px', border: '1px solid #ddd', color:'#FFF', textAlign:'right' }}>
                                            {payment.sum}₽
                                        </td>
                                    </tr>
                                ))
                            }
                        </>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Payments;